import React from "react";
//assets
import { Container, MessageContent, TextItem } from "./styles";
//interface
import { MessageAlertItemProps } from "./interface";

export const MessageItemSentBionexo: React.FC<MessageAlertItemProps> = (props) => {
  const { backgroundColor, borderColor, icon, sizeText, colorText, text } = props;

  return (
    <Container>
      <MessageContent backgroundColor={backgroundColor} borderColor={borderColor}>
        {icon}
        <TextItem sizeText={sizeText} colorText={colorText}>{text}</TextItem>
      </MessageContent>
    </Container>
  );
};